import React from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import ChannelsMarquee from './components/ChannelsMarquee';
import FullCycle from './components/FullCycle';
import Repositioning from './components/Repositioning';
import DemoSlot from './components/DemoSlot';
import Stats from './components/Stats';
import VideoSection from './components/VideoSection';
import Comparison from './components/Comparison';
import ROICalculator from './components/ROICalculator';
import Setup from './components/Setup';
import Integrations from './components/Integrations';
import Pricing from './components/Pricing';
import FAQ from './components/FAQ';
import FinalCTA from './components/FinalCTA';
import Footer from './components/Footer';
import './App.css';

function App() {
  return (
    <>
      <Navbar />
      <Hero />
      <ChannelsMarquee />
      <FullCycle />
      <Repositioning />
      <DemoSlot />
      <Stats />
      <VideoSection />
      <Comparison />
      <ROICalculator />
      <Setup />
      <Integrations />
      <Pricing />
      <FAQ />
      <FinalCTA />
      <Footer />
    </>
  );
}

export default App;
